module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/stopper-desktop-bg-5f8963b62c70726cc1acf7bdc52ccd9d.png";